import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteSelectV3Component, BannerModule, ButtonGroupV2Module, ButtonV3Component, CheckboxV2Module, CheckboxV3Component, ChipV3Component, IconV3Component, InputV3Component, LinkV2Module, ModalV2Module, PageHeaderModule, PageLayoutModule, SelectV2Module, SidebarV3Component, SnackbarModule, TabMenuV2Module, TooltipV2Module, WizardV2Module } from '@gea/digital-ui-lib';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ButtonV3Component,
    TabMenuV2Module,
    PageHeaderModule,
    PageLayoutModule,
    WizardV2Module,
    ModalV2Module,
    InputV3Component,
    BannerModule,
    SnackbarModule,
    LinkV2Module,
    SelectV2Module,
    CheckboxV2Module,
    IconV3Component,
    CheckboxV3Component,
    ButtonGroupV2Module,
    ChipV3Component,
    TooltipV2Module,
    SidebarV3Component,
    AutocompleteSelectV3Component
  ],
  exports: [ButtonV3Component, TabMenuV2Module, PageHeaderModule, PageLayoutModule, WizardV2Module, ModalV2Module, InputV3Component, BannerModule, SnackbarModule, LinkV2Module, SelectV2Module, CheckboxV2Module, IconV3Component, CheckboxV3Component, ButtonGroupV2Module, ChipV3Component, TooltipV2Module, SidebarV3Component, AutocompleteSelectV3Component
  ]
})
export class GeaLibraryModule { }
